import { chatChipNonVisblePages, inlineButtonChatPages } from './src-config-chat-config.js';
import { isHelpCenterHomepage } from './src-utils-chat-page-utils.js';
import { t } from './src-utils-translations.js';

const getButtonConfig = () => {
  const pageURL = window.location.href;
  if (chatChipNonVisblePages.find((ele) => pageURL.includes(t(ele)))) {
    return { enableChat: false };
  }
  if (isHelpCenterHomepage()) {
    return { buttonType: "hybrid", enableChat: true };
  }
  if (inlineButtonChatPages.find((ele) => pageURL.includes(t(ele)))) {
    return { buttonType: "inline", enableChat: true };
  }
  return { enableChat: true, buttonType: "floating" };
};

export { getButtonConfig };
//# sourceMappingURL=src-utils-chat-chat-button-utils.js.map
